// Shared T1D-stage checkbox list — the presentational block used by both
// OwnT1dFacet (own stage) and ChildrenT1dFacet (child stage). Centralises the
// checkbox markup and the T1D_STAGE_HELP tooltip icon so a11y/label changes
// live in one place.
import { T1D_STAGE_HELP } from "../../hooks/useT1dStages";

interface Props {
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  disabled?: boolean;
}

export function StageCheckboxList({ options, selected, onToggle, disabled }: Props) {
  return (
    <ul className="facet-checkbox-list">
      {options.map((s) => (
        <li key={s}>
          <label>
            <input
              type="checkbox"
              checked={selected.includes(s)}
              onChange={() => onToggle(s)}
              disabled={disabled}
            />
            <span>{s}</span>
            {T1D_STAGE_HELP[s] && (
              <span
                className="t1d-stage-facet__help"
                title={T1D_STAGE_HELP[s]}
                aria-hidden="true"
              >
                ⓘ
              </span>
            )}
          </label>
        </li>
      ))}
    </ul>
  );
}
